import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConnectionErrorComponent } from './otherpage/connection-error/connection-error/connection-error.component';
import { Page404Component } from './otherpage/page404/page404.component';
import { OAuthCheckComponent } from './login/oauthCheck/oauthCheck.component';
import { ConnectionSuccessComponent } from './otherpage/connectionsuccess/connection-success/connection-success.component';
import { Page401Component } from './otherpage/page401/page401.component';
import { PublicGuard } from './common/_guards/public.guard';

const routes: Routes = [
  { path: 'dashboard', redirectTo: 'auth/dashboard', pathMatch: 'full' },
  // Page not found
  {
    path: '404',
    component: Page404Component,
  },
  {
    path: '401',
    component: Page401Component,
  },
  {
    path: 'connection/success',
    component: ConnectionSuccessComponent,
    data: {
      public: true,
    },
  },
  {
    path: 'connection/error',
    component: ConnectionErrorComponent,
    data: {
      public: true,
    },
  },
  {
    path: 'oauthCheck',
    component: OAuthCheckComponent,
    data: {
      public: true,
    },
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [PublicGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginModule),
    canActivate: [PublicGuard],
    data: {
      public: true,
    },
  },
  {
    path: 'signUp',
    loadChildren: () => import('./login/signUp/signUp.module').then((m) => m.SignUpModule),
    canActivate: [PublicGuard],
    data: {
      public: true,
    },
  },
  {
    path: 'resetPassword/:id',
    loadChildren: () =>
      import('./login/resetPassword/resetPassword.module').then((m) => m.ResetPasswordModule),
    canActivate: [PublicGuard],
    data: {
      public: true,
    },
  },
  {
    path: 'forgotPassword',
    loadChildren: () =>
      import('./login/forgotPassword/forgotPassword.module').then((m) => m.ForgotPasswordModule),
    canActivate: [PublicGuard],
    data: {
      public: true,
    },
  },
  {
    path: 'redeem-coupon',
    loadChildren: () =>
      import('./reedem-coupon-page/reedem-coupon-page.module').then(
        (m) => m.ReedemCouponPageModule
      ),
  },
  {
    path: '',
    redirectTo: '/auth',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: '404',
    pathMatch: 'full',
  },
];

/*{
  path: 'validateUser/:id',
    loadChildren: () => import('./login/validateUser/validateUser.module').then(m => m.ValidateUserModule),
    canActivate: [PublicGuard],
    data: {
      public: true
    }
},*/
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
